/* DemoBadge — small pill identifying sandbox demo patients + cases.
 *
 * iter98.91 — Pre-seeded "Demo · Riya Sharma" lives under each doctor
 * so they can practise the wizard / approval / chat flows without
 * polluting real KPIs. The badge gives a UNAMBIGUOUS visual contract:
 * any time the doctor sees this violet pill, they're looking at
 * sandbox data — never something a real patient submitted.
 *
 * Two size variants:
 *   - default — table row + drawer chips (text-[10px] · py-0.5)
 *   - lg     — header / hero placements (text-xs · py-1)
 *
 * The violet hue is deliberately distinct from every other status
 * pill in the portal (teal for treatment, amber for action-needed,
 * rose for revision, emerald for success). Violet means "this is
 * pretend".
 */
import React from "react";
import { Flask } from "@phosphor-icons/react";

export default function DemoBadge({ size = "default", className = "" }) {
    const isLg = size === "lg";
    return (
        <span
            className={`inline-flex items-center gap-1 font-bold uppercase tracking-[0.16em] ${
                isLg ? "text-[11px] px-2 py-1" : "text-[9.5px] px-1.5 py-0.5"
            } rounded-full bg-violet-100 text-violet-800 ring-1 ring-violet-300 ${className}`}
            data-testid="demo-badge"
        >
            <Flask size={isLg ? 11 : 9} weight="fill" />
            Demo
        </span>
    );
}
